module.exports = __webpack_public_path__ + "static/chat-d28e422782590758178c04f5ba8c262f.png";